"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getRaf = exports.getIdle = exports.elementRect = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var defaultRect = (0, _freeze.default)({
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0
});
var elementRect = el => el ? el.getBoundingClientRect() : defaultRect;

// SEE: https://gist.github.com/paulirish/1579671 - Paul Irish's original.
exports.elementRect = elementRect;
var getRaf = function (_window) {
  var shim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!_window) return undefined;
  var raf = _window.requestAnimationFrame || _window.webkitRequestAnimationFrame || _window.mozRequestAnimationFrame || _window.msRequestAnimationFrame || _window.oRequestAnimationFrame;

  // NOTE: requestAnimation must be bound to the window
  if (raf) return (0, _bind.default)(raf).call(raf, _window);
  if (!shim) return undefined;
  var lastTime;
  return callback => {
    var currTime = (0, _now.default)();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = _window.setTimeout(callback, timeToCall, currTime + timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };
};
exports.getRaf = getRaf;
var getIdle = function (_window) {
  var shim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!_window) return undefined;
  var idle = _window.requestIdleCallback;
  // NOTE: idle must be bound to the window
  if (idle) return (0, _bind.default)(idle).call(idle, _window);
  if (!shim) return undefined;
  // SEE: https://developers.google.com/web/updates/2015/08/using-requestidlecallback
  return cb => {
    var start = (0, _now.default)();
    return _window.setTimeout(() => {
      cb({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - ((0, _now.default)() - start))
      });
    }, 1);
  };
};
exports.getIdle = getIdle;